import React from 'react';
import { concatStyles } from 'utils';
var SPLIT_STYLES = 'flex flex-col sm:flex-row w-full sm:h-full';
export var SplitColumn = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.maxWidth, maxWidth = _b === void 0 ? '84rem' : _b;
    return (React.createElement("div", { className: concatStyles([SPLIT_STYLES, className]), style: { maxWidth: maxWidth, minHeight: '100vh' } }, children));
};
SplitColumn.displayName = 'Layout.SplitColumn';
